import { AData } from "./AData";
import { ListResponse, UpcomingEventsRpc } from "rpc/UpcomingEventsRpc";

export class UpcomingEventsData extends AData<ListResponse> {

    private static data: ListResponse = null;

    protected doLoad(): Promise<ListResponse> {
        return UpcomingEventsRpc.list();
    }    
    
    protected getCached(): ListResponse {
        return UpcomingEventsData.data;
    }
    
    protected storeCached(data: ListResponse) {
        UpcomingEventsData.data = data;
    }


}